import React from 'react';
export const Header = () => {
  return <header className="w-full text-white py-4 px-4 md:px-8 shadow-sm" style={{
    backgroundColor: 'var(--color-primary)'
  }} data-id="element-320">
      <div className="container mx-auto flex items-center" data-id="element-321">
        <div className="flex items-center" data-id="element-322">
          <div className="mr-3 relative h-12 w-12 flex items-center justify-center bg-white/10 rounded-lg" data-id="element-323">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wbputTPKGLBnyq8nHNH1GM/ChatGPT_Image_Aug_26%2C_2025%2C_02_22_48_PM.png" alt="Frauengesundheit Logo" className="h-10 w-10 object-contain" data-id="element-324" />
          </div>
          <div data-id="element-325">
            <h1 className="font-bold text-xl md:text-2xl text-white tracking-tight" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-326">
              Frauengesundheit
            </h1>
            <p className="text-sm text-white/90" style={{
            fontFamily: 'Open Sans, sans-serif'
          }} data-id="element-327">
              Wissen
            </p>
          </div>
        </div>
      </div>
    </header>;
};